import endpoints from './endpoints';

const host = 'https://stg.posillicomaterials.com';
const api = 'https://posillico-cms-stg-b75cfbee0a17.herokuapp.com';

export default {
	host,
	api,

	bucket: 'https://posillicocmsstorage.blob.core.windows.net/production',

	endpoints: endpoints(api),

	externalUrl: {
		posillico: '//www.posillicoinc.com',
		materials: '//www.posillicomaterials.com',
	},
};
